import { render, staticRenderFns } from "./participants.vue?vue&type=template&id=3924bd12&scoped=true&"
import script from "./participants.vue?vue&type=script&lang=js&"
export * from "./participants.vue?vue&type=script&lang=js&"
import style0 from "./participants.vue?vue&type=style&index=0&id=3924bd12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924bd12",
  null
  
)

export default component.exports